var _style, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMotionIcon54(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M50,37c7.2,0,13,5.8,13,13s-5.8,13-13,13s-13-5.8-13-13S42.8,37,50,37L50,37z M13,0C5.8,0,0,5.8,0,13 s5.8,13,13,13s13-5.8,13-13S20.2,0,13,0L13,0z M87,0c-7.2,0-13,5.8-13,13s5.8,13,13,13s13-5.8,13-13S94.2,0,87,0L87,0z M13,74 C5.8,74,0,79.8,0,87s5.8,13,13,13s13-5.8,13-13S20.2,74,13,74L13,74z M87,74c-7.2,0-13,5.8-13,13s5.8,13,13,13s13-5.8,13-13 S94.2,74,87,74L87,74z M62,0H38v24h24V0L62,0z M62,76H38v24h24V76L62,76z M24,38H0v24h24V38L24,38z M100,38H76v24h24V38L100,38z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMotionIcon54);
export default __webpack_public_path__ + "static/media/motion_icon-54.3bb7a717.svg";
export { ForwardRef as ReactComponent };